import { render, staticRenderFns } from "./admin-closeemployee.vue?vue&type=template&id=477be634&"
import script from "./admin-closeemployee.vue?vue&type=script&lang=js&"
export * from "./admin-closeemployee.vue?vue&type=script&lang=js&"
import style0 from "./admin-closeemployee.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports